import { ReactNode } from 'react';

import { Typography } from '@beeline/design-system-react/extracted-styles';

import styles from './styles.module.scss';

type Props = { text?: string };
export function ShowcaseBanner({ text }: Props): ReactNode {
  if (!text) return null;

  return (
    <div className={styles.bannerContainer}>
      <Typography variant='body2'>{text}</Typography>
    </div>
  );
}
